import React from 'react';
import image1 from '../../images/apptouse/2.png';
import image2 from '../../images/apptouse/3.png';
import image3 from '../../images/apptouse/4.png';
import image4 from '../../images/apptouse/5.png';
const JumpingImages = () => {
  // You can replace these placeholder images with your actual image URLs
  const images = [
    image1,
    image2,
    image3,
    image4
 ];

 const isLargerMobile = window.innerWidth <= 1025;
 const isMobile = window.innerWidth <= 850;
 const isMidMobile = window.innerWidth <= 600;
 const issmallMobile = window.innerWidth <= 510;


  const styles = {
    body: {
      margin: 0,
      width:"50%",
      minHeight: '50vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: '"Klarheit Grotesk Regular", sans-serif',
      // Mobile overrides
      ...(isMobile && {
        padding: '0px',
        minHeight: "300px",
        width:"100%",
        marginTop:"30px"
      }),
      // Mobile overrides
      ...(issmallMobile && {
        padding: '0px',
        minHeight: "300px",
        width: "100%",
        maxWidth: "300px",
      })
    },
    container: {
      //background: 'rgba(0, 0, 0, 0.35)',
      margin:"0px",
      padding: '10px',
      borderRadius: '20px',
      textAlign: 'center',
      width: '100%',
      height: '400px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // Mobile overrides
      ...(isMobile && {
        margin: "50px",
        padding: '10px',
        height: '300px',
        width: "100%",
        borderRadius: '15px',
      })
    },
    imagesContainer: {
      position: 'relative',
      padding:"0px",
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // Mobile overrides
      ...(isMobile && {
        // Add any mobile-specific container styles here
        background:"transparent"
      })
    },
    imageItem: {
      position: 'absolute',
      height: '400px',
      aspectRatio:"9/14",
      borderRadius: '15px',
      overflow: 'hidden',
      transition: 'transform 0.3s ease',
      // Mobile overrides
      ...(isMobile && {
        height: '300px',
        borderRadius: '20px',
      })
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      // Mobile overrides
      ...(isMobile && {
        // Add any mobile-specific image styles here
      })
    },
    image1: {
      zIndex: 4,
      left: '66%',
      transform: 'translateX(-66%)',
      animation: 'jump1 2s infinite',
      // Mobile overrides
      ...(isLargerMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(80%)'
      }),
      ...(isMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(80%)'
      }),
      ...(isMidMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(80%)'
      }),
      ...(issmallMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(85%)'
      })
    },
    image2: {
      zIndex: 3,
      left: 'calc(66% - 90px)',
      transform: 'translateX(-66%)',
      animation: 'jump2 2s infinite',
      // Mobile overrides
      ...(isLargerMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(80% - 80px)'
      }),
      ...(isMobile && {
        left: 'calc(80% - 120px)'
      }),
      ...(isMidMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(80% - 90px)'
      }),
      ...(issmallMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(85% - 40px)'
      })
    },
    image3: {
      zIndex: 2,
      left: 'calc(66% - 180px)',
      transform: 'translateX(-66%)',
      animation: 'jump3 2s infinite',
      // Mobile overrides
      ...(isLargerMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(80% - 160px)'
      }),
      ...(isMobile && {
        left: 'calc(80% - 240px)'
      }),
      ...(isMidMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(80% - 180px)'
      }),
      ...(issmallMobile && {
        // Add any mobile-specific positioning here
         left: 'calc(85% - 80px)'
      })
    },
    image4: {
      zIndex: 1,
      left: 'calc(66% - 270px)',
      transform: 'translateX(-66%)',
      animation: 'jump4 2s infinite',
      // Mobile overrides
      ...(isLargerMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(80% - 240px)'
      }),
      ...(isMobile && {
        left: 'calc(80% - 360px)'
      }),
      ...(isMidMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(80% - 270px)'
      }),
      ...(issmallMobile && {
        // Add any mobile-specific positioning here
        left: 'calc(85% - 120px)'
      })
    }
  };

  return (
    <div style={styles.body}>
      <style>
        {`
          @keyframes jump1 {
            0%, 100% { transform: translateX(-50%) translateY(0); }
            10% { transform: translateX(-50%) translateY(-30px); }
            20% { transform: translateX(-50%) translateY(0); }
          }

          @keyframes jump2 {
            0%, 100% { transform: translateX(-50%) translateY(0); }
            20% { transform: translateX(-50%) translateY(-30px); }
            30% { transform: translateX(-50%) translateY(0); }
          }

          @keyframes jump3 {
            0%, 100% { transform: translateX(-50%) translateY(0); }
            30% { transform: translateX(-50%) translateY(-30px); }
            40% { transform: translateX(-50%) translateY(0); }
          }

          @keyframes jump4 {
            0%, 100% { transform: translateX(-50%) translateY(0); }
            40% { transform: translateX(-50%) translateY(-30px); }
            50% { transform: translateX(-50%) translateY(0); }
          }

          .image-item:hover {
            transform: translateX(-50%) translateY(-10px) scale(1.05) !important;
          }

           /* === MOBILE STYLES === */
          @media (max-width: 768px) {
            /* Mobile-specific animations - smaller jump height */
            @keyframes jump1 {
              0%, 100% { transform: translateX(-50%) translateY(0); }
              10% { transform: translateX(-50%) translateY(-20px); }
              20% { transform: translateX(-50%) translateY(0); }
            }

            @keyframes jump2 {
              0%, 100% { transform: translateX(-50%) translateY(0); }
              20% { transform: translateX(-50%) translateY(-20px); }
              30% { transform: translateX(-50%) translateY(0); }
            }

            @keyframes jump3 {
              0%, 100% { transform: translateX(-50%) translateY(0); }
              30% { transform: translateX(-50%) translateY(-20px); }
              40% { transform: translateX(-50%) translateY(0); }
            }

            @keyframes jump4 {
              0%, 100% { transform: translateX(-50%) translateY(0); }
              40% { transform: translateX(-50%) translateY(-20px); }
              50% { transform: translateX(-50%) translateY(0); }
            }

            /* Mobile hover effects - less dramatic */
            .image-item:hover {
              transform: translateX(-50%) translateY(-5px) scale(1.02) !important;
            }
          }

          /* === ADDITIONAL MOBILE BREAKPOINTS === */
          @media (max-width: 480px) {
            /* Extra small mobile devices */
            /* Add any specific styles for very small screens here */
          }

          @media (max-width: 320px) {
            /* Very small mobile devices */
            /* Add any specific styles for very small screens here */
          }

        `}
      </style>
      
      <div style={styles.container}>
        <div style={styles.imagesContainer}>
          {images.map((imageSrc, index) => (
            <div
              key={index}
              className="image-item"
              style={{
                ...styles.imageItem,
                ...styles[`image${index + 1}`]
              }}
            >
              <img
                src={imageSrc}
                alt={`Image ${index + 1}`}
                style={styles.image}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default JumpingImages;